export * from './post-dokument-hinterlegen.component';
export * from './post-dokument-hinterlegen.component.module';